import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { computed, extendObservable } from 'mobx'
import { formatDate, stringifyDate } from '@atheneum/api/dist/lib'
import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import { DatePicker } from '@components/DatePicker'
import propTypes from 'prop-types'
import moment from 'moment'
import WarningIcon from '@components/Icon/Warning'

class EPLInterviewedModal extends Component {
  static defaultProps = {
    shouldCloseOnOverlayClick: false,
    showCloseIcon: true
  }
  constructor (props) {
    super(props)

    const scheduledDate = props.eplModel.getScheduleDate()
    let defaultDate
    let warningDateChanged = false
    if (
      moment(scheduledDate)
        .startOf('day')
        .isAfter(moment().startOf('day'))
    ) {
      defaultDate = moment()
      warningDateChanged = true
    } else {
      defaultDate = scheduledDate
    }

    extendObservable(this, {
      format: 'YYYY-MM-DD',
      overrideDate: false,
      selectedDate: null,
      defaultDate,
      scheduledDate,
      error: null,
      submitting: false,
      interviewDate: computed(() => {
        if (this.overrideDate) {
          return stringifyDate(this.selectedDate)
        } else {
          return stringifyDate(this.defaultDate)
        }
      }),
      warningDateChanged
    })
  }

  handleDateChange = date => {
    this.selectedDate = date
  }

  toggleOverrideDate = e => {
    if (this.overrideDate) {
      this.error = null
      this.selectedDate = null
    }

    this.overrideDate = !this.overrideDate
  }

  onClose = () => {
    this.props.close({ updated: false })
  }

  handleSubmit = () => {
    if (this.submitting) return
    this.submitting = true

    if (this.overrideDate && !this.selectedDate) {
      this.error = 'Please select a date!'
      this.submitting = false
      return
    } else {
      this.error = null
    }

    if (!this.props.ruleStore.isBackdatingRuleSatisfied(this.interviewDate)) {
      this.error = 'Interview date does not meet the backdating rule criteria.'
      this.submitting = false
      return
    }

    return this.props.eplModel
      .handleInterviewed(this.interviewDate)
      .then(() => {
        this.props.close({ updated: true })
      })
      .catch(error => {
        this.props.growlStore.showError(error)
        this.props.close({ updated: false })
      })
      .then(() => {
        this.submitting = false
      })
  }

  renderConfirm = () => {
    const className = this.overrideDate ? 'EPLStatusModal__dateBlur' : null
    return (
      <div className='EPLStatusModal__confirm'>
        <h1>Confirm interviewed date</h1>
        <p>Please Confirm if the Interview date for this Expert is correct:</p>
        {this.warningDateChanged ? (
          <strong className='EPLStatusModal__dateBlur'>
            {formatDate(this.scheduledDate)}{' '}
          </strong>
        ) : null}
        <strong className={className}>{formatDate(this.defaultDate)}</strong>
        {this.warningDateChanged ? (
          <div className='warning-date-changed'>
            <WarningIcon />
            <div>Date changed to today!</div>
          </div>
        ) : null}
        <p>
          If this is correct, please click confirm, or change the date below:
        </p>
      </div>
    )
  }

  renderDateSelect = () => {
    return (
      <div className='EPLStatusModal__change'>
        <Checkbox
          label='Change to '
          value={this.overrideDate}
          onChange={this.toggleOverrideDate}
        />
        <DatePicker
          short
          onChange={this.handleDateChange}
          maxDate={moment().format('YYYY-MM-DD')}
          date={this.selectedDate}
          disabled={!this.overrideDate}
        />
      </div>
    )
  }

  renderErrorView = () => {
    return (
      <div>
        <p>There is a problem with this EPL - Missing Scheduled date</p>
        <Button onClick={this.onClose} secondary>
          Cancel
        </Button>
      </div>
    )
  }

  renderError = error => {
    if (!error) return null
    return <span className='EPLStatusModal__error'>{error}</span>
  }

  render () {
    if (!this.defaultDate) return this.renderErrorView()

    return (
      <div className='EPLStatusModal'>
        {this.renderConfirm()}
        {this.renderDateSelect()}
        {this.renderError(this.error)}

        <Button onClick={this.handleSubmit} primary disabled={this.submitting}>
          Confirm
        </Button>
        <Button onClick={this.onClose} secondary>
          Cancel
        </Button>
      </div>
    )
  }
}

EPLInterviewedModal.propTypes = {
  eplModel: propTypes.object,
  ruleStore: propTypes.object,
  growlStore: propTypes.object,
  close: propTypes.func
}

export default inject('growlStore', 'ruleStore')(observer(EPLInterviewedModal))
